<template>
  <aside>
    <div class="block block_yellow">
      <div class="block__top">
        <div class="block__left">
          <img src="@/assets/icon-news-sidebar.svg" />
        </div>
        <div class="block__right">
          <h2 class="block__heading">{{ $t("LATEST NEWS") }}</h2>
          <ul class="block__list" v-if="!news.length">
            <li class="block__item block__item_stub" v-for="n in 3" :key="n">
              n
            </li>
          </ul>
          <ul v-else>
            <li v-for="item in news" :key="item.id" class="block__item">
              <router-link :to="`/news/${item.id}`" class="block__link">{{
                item.title
              }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="block__bottom">
        <router-link to="/news" class="block__more"
          >{{ $t("MORE_NEWS") }}
          <img class="block__more-icon"
            :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-chevron.svg`)" />
        </router-link>
      </div>
    </div>

    <div
      class="devices block block_purple"
      :class="{ block_devices: devices.length }"
    >
      <div class="block__top">
        <div class="block__left">
          <img src="@/assets/icon-device-sidebar.svg" />
        </div>
        <div class="block__right">
          <template v-if="!devices.length">
            <h2 class="block__heading block__heading_small">
              <i18next
                path="YOUR_DEVICE"
                class="block__heading block__heading_small"
              >
                <img
                  class="block__heading-icon"
                  src="@/assets/icon-apple.svg"
                />
              </i18next>
            </h2>
            <p class="block__text">{{ $t("NO_DEVICE_LINKED_TO_APPDB") }}</p>
            <router-link class="block__link-device" to="/link">{{
              $t("LINK_YOUR_DEVICE")
            }}</router-link>
          </template>
          <template v-else>
            <h2 class="block__heading block__heading_small">
              {{ $t("DEVICES_LINKED_COUNT", { count: devices.length }) }}
              <img class="block__heading-icon" src="@/assets/icon-check.svg" />
            </h2>
            <template v-for="(device, index) in devices">
              <p class="block__device-name" :key="index">
                {{ $t("DEVICE_NAME", { name: device.name }) }}
              </p>
              <p class="block__device-desc" :key="index + 't'">
                {{ device.title }})
              </p>
            </template>
            <router-link to="/my/devices" class="block__device-page"
              >{{ $t("VIEW_DEVICES_PAGE") }}
              <img class="block__more-icon"
                :src="require(`@/assets/themes/${BRAND_KEY}/images/icon-chevron.svg`)"
            /></router-link>
          </template>
        </div>
      </div>
    </div>

    <telegram-discussion
      v-if="BRAND_CONFIG.telegramDiscussion"
      :discussion="BRAND_CONFIG.telegramDiscussion"
      class="telegram"
      :comments-limit="3"
      :height="540"
    />
  </aside>
</template>
<script>
import { mapState } from 'vuex';
import TelegramDiscussion from './TelegramDiscussion.vue';

export default {
  components: { TelegramDiscussion },
  data() {
    return {
      news: [],
      langKey: 0,
    };
  },
  computed: {
    devices() {
      return this.$store.getters.devices;
    },
    ...mapState(['theme']),
  },
  watch: {
    // eslint-disable-next-line
    '$store.getters.lang': function () {
      this.langKey += 1;
    },
  },
  methods: {
    getNews() {
      return this.$api.getNews().then((data) => {
        this.news = data;
      });
    },
  },
  serverPrefetch() {
    return this.getNews();
  },
  created() {
    this.getNews();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.block {
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
  overflow: hidden;
  position: relative;

  @include notebook {
    padding: 10px;
    margin-bottom: 0;
  }

  &_yellow {
    background-image: var(--yellow-gradient);
    border: 1px solid var(--yellow-border);
  }

  &_purple {
    background-image: var(--purple-gradient);
    border: 1px solid var(--purple-border);
    max-height: 140px;
  }

  &_devices {
    min-height: 120px;
  }

  &__top,
  &__bottom {
    display: flex;
  }

  &__left {
    @include notebook {
      display: none;
    }
  }

  &__right {
    margin-left: 15px;
    min-width: 0;
    flex-grow: 1;

    @include notebook {
      margin-left: 0;
    }
  }

  &__heading {
    font-size: 20px;
    color: var(--text-primary);
    font-weight: 600;
    margin-bottom: 10px;

    @include notebook {
      display: none;
    }

    &-icon {
      margin: 0 4px;
      filter: var(--img-filter);
    }

    &_small {
      display: flex;
      font-size: 16px;
    }
  }

  &__item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px;

    &_stub {
      background-color: var(--stub-bg);
      border-radius: 6px;
      color: transparent;
      display: block;
    }

    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }

  &__link {
    color: $primary;
  }

  &__more {
    display: flex;
    align-items: center;
    margin-top: 15px;
    margin-left: auto;
    color: var(--text-tertiary);
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;

    &-icon {
      height: 9px;
      margin-top: 1px;
      margin-left: 5px;
    }
  }

  &__text {
    color: var(--text-primary);
  }

  &__link-device {
    display: inline-block;
    margin-top: 20px;
    background: var(--bg);
    border: 1px solid lighten($primary, 35);
    border-radius: 2px;
    padding: 5px 10px;
    color: $primary;
    font-weight: 500;
  }

  &__device-desc {
    margin-bottom: 20px;
  }

  &__device-page {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bg-transparent);
    box-shadow: 0 -1px 4px 0 rgba(203, 203, 203, 0.3);
    padding: 10px 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: var(--text-tertiary);
    font-weight: 600;
    font-size: 12px;
  }
}

.telegram {
  border-radius: 10px;
  border: 1px solid var(--tertiary-accent);
  overflow: hidden;

  ::v-deep iframe {
    float: left;
  }
}

.devices,
.telegram {
  @include notebook {
    display: none;
  }
}
</style>
